
const eventview = [{"key":"eventview.title","string":"Udalosti, ktoré ste pridali"},{"key":"eventview.add_event_button","string":"Pridať udalosť"},{"key":"eventview.no_event_added","string":"Nepridali ste zatiaľ žiadnu udalosť na medzinárodnú expertnú platformu."},{"key":"eventview.table.title","string":"Názov"},{"key":"eventview.table.location","string":"Miesto konania"},{"key":"eventview.table.date","string":"Dátum"},{"key":"eventview.gotowebsite","string":"Prejsť na webovú stránku"}]

export default eventview



// WEBPACK FOOTER //
// ./src/i18n/sk/addevent/eventview.js